exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2e501KUZWsWCoGG00UPQ-O {\n    padding: 20px 20px 50px;\n}\n\n._2EEtMrrZoPYj5MesnPHnuK {\n    text-align: center;\n}\n\n.OObF7fihf8-uM5-YCkaqm {\n    padding-top: 50px;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_2e501KUZWsWCoGG00UPQ-O",
	"category": "_2EEtMrrZoPYj5MesnPHnuK",
	"imageContainer": "OObF7fihf8-uM5-YCkaqm"
};